var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from '../elements/icon';
import { classNames } from '@shapeable/utils';
import { useFullscreen } from '../hooks/use-fullscreen';
import { useLang } from '../hooks/use-lang';
import { useSite } from '../hooks/use-site';
import { useSiteSidebar } from '../hooks/use-site-sidebar';
import { FullscreenEnterIconGlyph, FullscreenExitIconGlyph } from '@shapeable/icons';
var cls = classNames('site-sidebar');
export var SiteSidebarDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    transition: filter 0.2s;\n    height: 100%;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 600;\n    ", "\n\n    ", "\n\n    font-family: ", ";\n    ", ";\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  "], ["\n    color: ", ";\n    transition: filter 0.2s;\n    height: 100%;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 600;\n    ", "\n\n    ", "\n\n    font-family: ", ";\n    ", ";\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  "])), theme.COLOR('light'), function (_a) {
    var hasOnClick = _a.hasOnClick;
    return hasOnClick && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "])));
  }, function (_a) {
    var _width = _a._width,
      _color = _a._color;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: ", "px;\n      background: ", ";\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "], ["\n      width: ", "px;\n      background: ", ";\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "])), _width, _color);
  }, theme.FONT('sans'), theme.FILL('light')),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FullscreenButtonStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    cursor: pointer;\n    padding: ", ";\n  "], ["\n    cursor: pointer;\n    padding: ", ";\n  "])), theme.UNIT(5))
});
var BodyStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  FullscreenButton: styled(Icon)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), FullscreenButtonStyles)
};
/* @ts-ignore */
export var SiteSidebar = React.forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var site = useSite();
  var t = useLang();
  var fullscreen = useFullscreen();
  var sidebar = useSiteSidebar();
  var onClick = props.onClick || sidebar.onClick;
  return React.createElement(My.Container, {
    hasOnClick: !!onClick,
    onClick: onClick,
    _color: sidebar.color,
    _width: sidebar.width,
    className: cls.name(className)
  }, React.createElement(My.Body, {
    ref: ref
  }, sidebar.showFullscreenButton && React.createElement(My.FullscreenButton, {
    size: 24,
    onClick: fullscreen.toggleOnClick
  }, fullscreen.isActive ? React.createElement(FullscreenExitIconGlyph, null) : React.createElement(FullscreenEnterIconGlyph, null)), sidebar.buttons));
});
SiteSidebar.defaultProps = SiteSidebarDefaultProps;
SiteSidebar.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;